import React from "react";
import { ReserveFieldUsers } from "@/features/reserve/components/ReserveFieldUsers/ReserveFieldUsers";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";
import { useAuthenticated } from "@gettactic/hooks";
import { getRoomGuestPickerRules } from "@/features/reserve/utils/getRoomGuestPickerRules";

export interface ReserveFormMeetingRoomUsersSelectorProps {
  defaultUsers?: string[];
}

export const ReserveFormMeetingRoomUsersSelector: React.FC<
  ReserveFormMeetingRoomUsersSelectorProps
> = ({ defaultUsers }) => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  const { form, enableAdminReservation, organizerId } = useReserveForm();
  const authUserId = authenticatedUser?.user?.id;
  const { excludedUserId, shouldOfferCurrentUser } = getRoomGuestPickerRules({
    organizerId: enableAdminReservation ? organizerId : (authUserId ?? null),
    authUserId
  });

  return (
    <ReserveFieldUsers
      form={form}
      single={false}
      defaultValue={defaultUsers || []}
      excludedUserId={excludedUserId}
      shouldOfferCurrentUser={shouldOfferCurrentUser}
      errors={form.formState.errors}
    />
  );
};
